import { injectChild } from "@components/constructor";
import { usePromisedDispatch } from "@hooks/helperHooks";
import { dailyActions } from "@store/user/userDailyStore";
import { toastr } from "@/utils/toastHelper";
import { FC, PropsWithChildren, useCallback, useMemo, useState } from "react";

const DailyGiftReceive: FC<PropsWithChildren> = ({ children }) => {

    const dispatch = usePromisedDispatch();
    const [receivingGift, setRecGift] = useState(false);

    const receiveGift = useCallback(async () => {
        setRecGift(true);

        const result = await dispatch(dailyActions.checkGitfs());
        if(result.success) {
            if(result.data.newGifts.length > 0) {
                toastr.success("Подарки", "Получены новые подарки");
            }
            else if(result.data.updatedGifts.length > 0) {
                toastr.success("Подарки", "Прогресс обновлен, подарок уже был выдан ранее");
            }
            else {
                toastr.success("Подарки", "Прогресс обновлен, но нет подарков для получения");
            }
        }
        else {
            if(result.errorCode === 'NoGifts') {
                toastr.success("Подарки", "Нет подарков для получения");
            }
            else if(result.errorCode === 'HasToday') {
                toastr.success("Подарки", "Сегодня Вы уже запрашивали получение подарка");
            }
            else {
                toastr.error("Подарки", "Что-то пошло не так");
            }
        }

        setRecGift(false);
    }, [dispatch]);

    const data = useMemo(() => {
        return {
            receive_gift: receiveGift,
            receiving_gift: receivingGift
        }
    }, [receiveGift, receivingGift]);

    return injectChild(data, children);
}

export default DailyGiftReceive;
